/**
 * Main banner (bottom CTA bar): close and collapse behaviour.
 * - "Plus tard" / close button: dismisses the banner (hidden for the session).
 * - Chevron: toggles collapsed state (minimal bar) vs expanded (full content).
 * Uses event delegation so clicks work even if banner is in the DOM later.
 */

const STORAGE_KEY = 'lgc_main_banner_dismissed'

export function initMainBanner() {
  const banner = document.getElementById('main-banner')
  if (banner && sessionStorage.getItem(STORAGE_KEY) === '1') {
    banner.classList.add('is-dismissed')
  }

  document.body.addEventListener('click', (e) => {
    const bannerEl = document.getElementById('main-banner')
    if (!bannerEl) return

    const closeBtn = e.target.closest('.js-banner-close')
    const toggleBtn = e.target.closest('.js-banner-toggle')
    if (!closeBtn && !toggleBtn) return
    if (!bannerEl.contains(closeBtn) && !bannerEl.contains(toggleBtn)) return

    if (closeBtn) {
      e.preventDefault()
      e.stopPropagation()
      bannerEl.classList.add('is-dismissed')
      sessionStorage.setItem(STORAGE_KEY, '1')
    }
    if (toggleBtn) {
      e.preventDefault()
      e.stopPropagation()
      bannerEl.classList.toggle('is-collapsed')
    }
  })
}
